import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Row, Col } from 'antd';
import getFormData from 'get-form-data';

import FieldsGroup from '@atoms/form/fields-group';

import { fieldChange, fieldValidation, NUMBER_RULES } from 'FIELDS';
import { InputsSet } from 'INPUTS';
import { tConsume } from 'TRANSLATION';
import defaults from 'DEFAULTS';
import './tfaQr.less';

class TfaQrForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tfa_code: {
        name: 'tfa_code',
        type: 'number',
        accept: defaults.re.digits,
        required: true,
        placeholder: true,
        label: props.t('field.code'),
        [NUMBER_RULES.LENGTH]: 6,
        autofocus: true,
      },
      secretKey: {
        name: 'key',
        type: 'text',
        required: false,
        placeholder: true,
        label: 'Key',
        value: props.secretKey,
      },
      isQr: true,
    };

    this.handleFieldChange = fieldChange.bind(this, this);
    this.fieldValidation = fieldValidation.bind(this, this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  async handleSubmit(event) {
    event.preventDefault();
    const { onConfirm } = this.props;
    const data = getFormData(event.target, { trim: true });

    if (!!data && this.fieldValidation()) {
      onConfirm({ tfa_code: data.tfa_code });
    }
  }

  handleClick(event) {
    event.preventDefault();
    this.setState((prevState) => ({
      ...prevState,
      tfa_code: { ...prevState.tfa_code, value: null },
      isQr: !prevState.isQr,
    }));
  }

  render() {
    const { type, qrSrc, loading, t } = this.props;
    const { tfa_code, isQr } = this.state;

    return (
      <div className='qr-wrapper'>
        <div className='setup-2fa'>
          <div className='step'>
            <div className='step-circle'>1</div>
            <div className='step-content'>
              <div className='step-header'>
                <span className='step-label'>STEP 1</span>
                <h3 className='step-title'>Download Google Authenticator app</h3>
              </div>
              <p className='step-description'>You can download it to your device from the App Store and Google Play.</p>
            </div>
          </div>

          <div className='step'>
            <div className='step-circle'>2</div>
            <div className='step-content'>
              <div className='step-header'>
                <span className='step-label'>STEP 2</span>
                <h3 className='step-title'>{isQr ? 'Scan QR-code' : 'Verification with Authenticator App'}</h3>
              </div>
              <p className='step-description'>
                {isQr
                  ? ' Open authenticator and choose scan code.'
                  : 'Enter the 6-digit code generated by your authenticator app.'}
              </p>
            </div>
          </div>
        </div>

        <div className='qr-block'>
          {isQr ? (
            <Form onSubmit={this.handleSubmit}>
              {type === 'bind' && <div className={'qrCode'}>{qrSrc && <img src={qrSrc} alt={'qrcode'} />}</div>}

              <FieldsGroup title={`${t('component.tfa.google_description')}`} />

              <Row gutter={20}>
                <Col sm={16}>{InputsSet(this, ['tfa_code'])}</Col>
                <Col sm={8}>
                  <Button
                    size={defaults.antd.button.size}
                    loading={loading}
                    htmlType={'submit'}
                    type={'primary'}
                    disabled={tfa_code.value?.length !== 6}
                    block
                  >
                    {t('button.confirm')}
                  </Button>
                </Col>
              </Row>
            </Form>
          ) : (
            <Form onSubmit={this.handleSubmit}>
              <Row>
                <Col>{InputsSet(this, ['secretKey'])}</Col>
              </Row>
              <FieldsGroup title={`${t('component.tfa.google_description')}`} />
              <Row gutter={20}>
                <Col sm={16}>{InputsSet(this, ['tfa_code'])}</Col>
                <Col sm={8}>
                  <Button
                    size={defaults.antd.button.size}
                    loading={loading}
                    htmlType={'submit'}
                    type={'primary'}
                    disabled={tfa_code.value?.length !== 6}
                    block
                  >
                    {t('button.confirm')}
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </div>

        {/*<Button type='dashed' size={'large'} onClick={this.handleClick} block>*/}
        {/*  {isQr ? 'CHOOSE ALTERNATIVE METHOD' : 'BACK TO METHOD WITH QR-CODE SCANNING'}*/}
        {/*</Button>*/}
      </div>
    );
  }
}

export default tConsume(TfaQrForm);

TfaQrForm.propTypes = {
  type: PropTypes.oneOf(['bind', 'get', 'check']),
  loading: PropTypes.bool,
  qrSrc: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  secretKey: PropTypes.string,
};

TfaQrForm.defaultProps = {
  loading: false,
};
